export const DRAWING_FACES = [
  { value: "top", label: "Planta (superior)", short: "Planta" },
  { value: "bottom", label: "Inferior", short: "Inferior" },
  { value: "front", label: "Alzado frontal", short: "Frontal" },
  { value: "back", label: "Alzado posterior", short: "Posterior" },
  { value: "left", label: "Lateral izquierdo", short: "Izquierda" },
  { value: "right", label: "Lateral derecho", short: "Derecha" },
];

export const FACE_LABEL = Object.fromEntries(DRAWING_FACES.map((f) => [f.value, f.label]));
export const FACE_SHORT = Object.fromEntries(DRAWING_FACES.map((f) => [f.value, f.short]));
